import { createContext } from 'react';
import { SessionController } from '../controllers/SessionController';
import StatefulSettings from '../controllers/StatefulSettings';

export const SelectedSettingsContext = createContext<StatefulSettings>({} as StatefulSettings);
export const ControllerContext = createContext<SessionController>({} as SessionController);